import { render, staticRenderFns } from "./get_sub_behavioural.vue?vue&type=template&id=1edf6cb3&"
import script from "./get_sub_behavioural.vue?vue&type=script&lang=js&"
export * from "./get_sub_behavioural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports